module.exports = __webpack_public_path__ + "img/dcc3cab.png";